<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="17" height="17" rx="3.5" fill="black"/>
    <rect x="0.5" y="0.5" width="17" height="17" rx="3.5" stroke="black"/>
    <path d="M4.63086 9.25L7.89173 11.9674L13.3265 5.44565" stroke="white" stroke-width="2"/>
  </svg>

</template>

<script>
  export default {
    name: "CheckMarkFilled"
  }
</script>

<style scoped>

</style>